module.exports = __webpack_public_path__ + "img/seven-layer-dip.2246cc75.jpg";